// Class name used to prevent editor typography styles from affecting embedded content
export const EDITOR_STYLE_BOUNDARY_CLASS = "editor-style-boundary";
